import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  DoDeposit,
  GetDepositList,
  GetEventList,
  DeleteDeposit,
} from "../../common/actions/moreAction";
import {
  convertDepositString,
  convertStyle,
  dateFormation,
  isEmpty,
  isMobilePage,
  moneyValues,
  no_comma,
  toastr,
} from "../../common/cores";
import Pagenation from "../common/Pagenation";
import NavLink from "react-router-dom/NavLink";
import Footbar from "../Layout/Footbar";
import { isMobile } from "../../utils/utils";
const WithDrawalContent = (props) => {
  const [money, setMoney] = useState(0);
  const [showHis, setShowHis] = useState(false);
  const [withdrawPassword, setWithdrawPassword] = useState("");
  const lists = props.deposit.data;
  const { page, user } = props;
  const [ids, setIds] = useState([]);

  const getLists = (page) => {
    props.GetDepositList("withdraw", page);
  };

  const password = (e) => {
    setWithdrawPassword(e.target.value);
  };

  const reset = () => {
    setMoney(0);
  };

  const onChange = (e) => {
    const { value, checked } = e.target; // 우선 e.target 에서 name 과 value 를 추출
    console.log(isNaN(Number(value)));
    if (checked) setIds([...ids, value]);
    else setIds(ids.filter((item) => item !== value));
    console.log(ids);
    if (!isNaN(Number(no_comma(value)))) setMoney(Number(no_comma(value)));
    else setMoney(0);
  };

  useEffect(() => {
    getLists(1);
  }, [props.page.perPage]);

  const historyDelete = (value) => {
    props.DeleteDeposit({
      ids,
      all: value,
      typeStr: "withdraw",
    });
  };

  const showHisotry = () => {
    setShowHis(!showHis);
  };

  const getMoneyFormat = (val) => {
    let res = "";
    if (val / 10000 > 0) res += val / 10000 + "만원";
    val = val % 10000;
    if (val / 1000 > 0) res += val / 1000 + "천원";
    val = val % 1000;
    if (val / 100 > 0) res += val / 100 + "백원";
    val = val % 100;
    if (val / 10 > 0) res += val / 10 + "십원";
    val = val % 10;
    if (val != 0) res += val;
    return res;
  };

  const onWithdraw = () => {
    if (money <= 0) {
      return toastr.warning(
        `${
          isEmpty(window.lang["머니를 입력해주세요."])
            ? "머니를 입력해주세요."
            : window.lang["머니를 입력해주세요."]
        }`
      );
    }
    if (isEmpty(withdrawPassword)) {
      return toastr.warning(
        `${
          isEmpty(window.lang["출금 비밀번호를 입력 하세요"])
            ? "출금 비밀번호를 입력 하세요"
            : window.lang["출금 비밀번호를 입력 하세요"]
        }`
      );
    }
    if (money < 10000) {
      return toastr.warning(
        `${
          isEmpty(
            window.lang[
              "출금 신청시 반드시 최소 롤링이 충족되어야 출금이 가능합니다."
            ]
          )
            ? "출금 신청시 반드시 최소 롤링이 충족되어야 출금이 가능합니다."
            : window.lang[
                "출금 신청시 반드시 최소 롤링이 충족되어야 출금이 가능합니다."
              ]
        }`
      );
    }
    let withdrawMoney = Math.floor(money / 10000) * 10000;
    props.DoDeposit(withdrawMoney, "withdraw", withdrawPassword);
  };
  return (
    <div className="mypage_cont" style={{ paddingTop: isMobile() && 0 }}>
      <div className="contents_box">
        <div className="con_box00">
          <div className="tab_wrap">
            <ul style={{ flexWrap: isMobile() && "nowrap" }}>
              <li>
                <NavLink to="/withdraw">
                  <span className="tab">
                    {isEmpty(window.lang["출금신청"])
                      ? "출금신청"
                      : window.lang["출금신청"]}
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/withdraw/details">
                  <span className="tab">
                    {isEmpty(window.lang["출금내역"])
                      ? "출금내역"
                      : window.lang["출금내역"]}
                  </span>
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
        <div className="con_box10">
          {!isMobile() && (
            <div className="info_wrap">
              <div className="info1">
                <span className="info_title1">
                  {isEmpty(window.lang["확인"]) ? "확인" : window.lang["확인"]}{" "}
                  /{" "}
                  {isEmpty(window.lang["주의사항"])
                    ? "주의사항"
                    : window.lang["주의사항"]}
                </span>
              </div>
              <div className="info3">
                <img src="images/dot.jpg" className="dot" />{" "}
                <span className="font05">
                  {isEmpty(
                    window.lang[
                      "입금하실 시, 예금주명은 회원님 성함으로 필히 입금바랍니다."
                    ]
                  )
                    ? "입금하실 시, 예금주명은 회원님 성함으로 필히 입금바랍니다."
                    : window.lang[
                        "입금하실 시, 예금주명은 회원님 성함으로 필히 입금바랍니다."
                      ]}
                </span>
                <br />
                <img src="images/dot.jpg" className="dot" />{" "}
                {isEmpty(
                  window.lang[
                    "은행 점검시간을 확인하신 후 해당시간에는 입금이 지연될 수 있으니 점검시간을 피해 신청해 주시기 바랍니다."
                  ]
                )
                  ? "은행 점검시간을 확인하신 후 해당시간에는 입금이 지연될 수 있으니 점검시간을 피해 신청해 주시기 바랍니다."
                  : window.lang[
                      "은행 점검시간을 확인하신 후 해당시간에는 입금이 지연될 수 있으니 점검시간을 피해 신청해 주시기 바랍니다."
                    ]}
                <br />
                <img src="images/dot.jpg" className="dot" />{" "}
                {isEmpty(
                  window.lang[
                    "자세한 문의사항은 고객센터(1:1문의)를 이용해 주시기 바랍니다."
                  ]
                )
                  ? "자세한 문의사항은 고객센터(1:1문의)를 이용해 주시기 바랍니다."
                  : window.lang[
                      "자세한 문의사항은 고객센터(1:1문의)를 이용해 주시기 바랍니다."
                    ]}
                <br />
              </div>
            </div>
          )}
        </div>
        {!isMobile() && (
          <div className="con_box10">
            <div className="info_wrap">
              <div className="info1">
                <span className="info_title1">
                  {isEmpty(window.lang["입금 계좌정보 확인"])
                    ? "입금 계좌정보 확인"
                    : window.lang["입금 계좌정보 확인"]}
                </span>
              </div>
              <div className="info3">
                <img src="images/dot.jpg" className="dot" />{" "}
                {isEmpty(
                  window.lang[
                    "입금 계좌번호는 쪽지로 발송되며, 계좌번호로 선 입금 바랍니다."
                  ]
                )
                  ? "입금 계좌번호는 쪽지로 발송되며, 계좌번호로 선 입금 바랍니다."
                  : window.lang[
                      "입금 계좌번호는 쪽지로 발송되며, 계좌번호로 선 입금 바랍니다."
                    ]}
              </div>
            </div>
          </div>
        )}
        <div className="con_box10">
          <div className="write_wrap">
            <div className="write1">
              <span className="info_title2">
                {isEmpty(window.lang["출금신청 금액"])
                  ? "출금신청 금액"
                  : window.lang["출금신청 금액"]}
              </span>
            </div>
            {!isMobilePage() && (
              <div className="write3">
                <table
                  width="100%"
                  border="0"
                  cellSpacing="0"
                  cellPadding="0"
                  className="write_title_top"
                >
                  <tbody>
                    <tr>
                      <td className="write_title">
                        {isEmpty(window.lang["현재 보유머니"])
                          ? "현재 보유머니"
                          : window.lang["현재 보유머니"]}
                      </td>
                      <td className="write_basic" style={{ fontSize: " 16px" }}>
                        ￦
                        <span className="font14">
                          {!isEmpty(user.data.balance)
                            ? Number(user.data.balance.money).toLocaleString()
                            : 0}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="write_title deposit-money">
                        {isEmpty(window.lang["출금신청 금액"])
                          ? "출금신청 금액"
                          : window.lang["출금신청 금액"]}
                      </td>
                      <td className="write_basic">
                        <input
                          type="text"
                          placeholder={
                            isEmpty(window.lang["출금신청 금액"])
                              ? "출금신청 금액"
                              : window.lang["출금신청 금액"]
                          }
                          inputMode="numeric"
                          className="input1"
                          value={Number(money).toLocaleString()}
                          onChange={onChange}
                          style={{ backgroundColor: "white" }}
                        />
                        <br />
                        <br />
                        {moneyValues.map((item, index) => {
                          return (
                            <a key={index}>
                              <span
                                className="btn1_2"
                                key={index}
                                style={{ marginRight: "4px" }}
                                onClick={() => setMoney(money + item.value)}
                              >
                                {item.text}
                              </span>
                            </a>
                          );
                        })}
                        <a>
                          <span
                            className="btn1_1"
                            onClick={() => setMoney(0)}
                            style={{ marginRight: "4px" }}
                          >
                            {isEmpty(window.lang["초기화"])
                              ? "초기화"
                              : window.lang["초기화"]}
                          </span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td className="write_title">
                        {isEmpty(window.lang["출금 비밀번호"])
                          ? "출금 비밀번호"
                          : window.lang["출금 비밀번호"]}
                      </td>
                      <td className="write_basic">
                        <input
                          data-v-5b7f4dd8=""
                          data-v-66023d98=""
                          type="password"
                          placeholder={
                            isEmpty(window.lang["출금 비밀번호를 입력 하세요"])
                              ? "출금 비밀번호를 입력 하세요"
                              : window.lang["출금 비밀번호를 입력 하세요"]
                          }
                          inputMode="text"
                          className="input1"
                          value={withdrawPassword}
                          style={{ backgroundColor: "white" }}
                          onChange={password}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            {isMobilePage() && (
              <div className="write3">
                <table
                  width="100%"
                  border="0"
                  cellSpacing="0"
                  cellPadding="0"
                  className="write_title_top"
                >
                  <tbody>
                    <tr>
                      <td className="write_title" style={{ width: "30%" }}>
                        {isEmpty(window.lang["현재 보유머니"])
                          ? "현재 보유머니"
                          : window.lang["현재 보유머니"]}
                      </td>
                      <td className="write_basic" style={{ fontSize: " 16px" }}>
                        ￦
                        <span className="font14">
                          {!isEmpty(user.data.balance)
                            ? Number(user.data.balance.money).toLocaleString()
                            : 0}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="write_title" style={{ width: "30%" }}>
                        {isEmpty(window.lang["출금신청 금액"])
                          ? "출금신청 금액"
                          : window.lang["출금신청 금액"]}
                      </td>
                      <td className="write_basic">
                        <input
                          type="text"
                          placeholder={
                            isEmpty(window.lang["출금신청 금액"])
                              ? "출금신청 금액"
                              : window.lang["출금신청 금액"]
                          }
                          inputMode="numeric"
                          className="input1"
                          value={Number(money).toLocaleString()}
                          onChange={onChange}
                          style={{ backgroundColor: "#fff" }}
                        />
                        <table
                          width="100%"
                          border="0"
                          align="center"
                          cellSpacing="2"
                          cellPadding="0"
                        >
                          <tbody>
                            <tr>
                              <td width="10%" align="center">
                                <a>
                                  <span
                                    className="m_btn1_2"
                                    onClick={() => setMoney(money + 10000)}
                                  >
                                    10,000
                                  </span>
                                </a>
                              </td>
                              <td width="10%" align="center">
                                <a>
                                  <span
                                    className="m_btn1_2"
                                    onClick={() => setMoney(money + 30000)}
                                  >
                                    30,000
                                  </span>
                                </a>
                              </td>
                              <td width="10%" align="center">
                                <a>
                                  <span
                                    className="m_btn1_2"
                                    onClick={() => setMoney(money + 50000)}
                                  >
                                    50,000
                                  </span>
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <td width="10%" align="center">
                                <a>
                                  <span
                                    className="m_btn1_2"
                                    onClick={() => setMoney(money + 100000)}
                                  >
                                    100,000
                                  </span>
                                </a>
                              </td>
                              <td width="10%" align="center">
                                <a>
                                  <span
                                    className="m_btn1_2"
                                    onClick={() => setMoney(money + 500000)}
                                  >
                                    500,000
                                  </span>
                                </a>
                              </td>
                              <td width="10%" align="center">
                                <a>
                                  <span
                                    className="m_btn1_2"
                                    onClick={() => setMoney(money + 1000000)}
                                  >
                                    1,000,000
                                  </span>
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <td width="10%" align="center">
                                <a>
                                  <span
                                    className="m_btn1_2"
                                    onClick={() => setMoney(money + 5000000)}
                                  >
                                    5,000,000
                                  </span>
                                </a>
                              </td>
                              <td width="10%" align="center">
                                <a>
                                  <span
                                    className="m_btn1_2"
                                    onClick={() => setMoney(money + 10000000)}
                                  >
                                    10,000,000
                                  </span>
                                </a>
                              </td>
                              <td width="10%" align="center">
                                <a>
                                  <span
                                    className="m_btn1_1"
                                    onClick={() => setMoney(0)}
                                  >
                                    {isEmpty(window.lang["초기화"])
                                      ? "초기화"
                                      : window.lang["초기화"]}
                                  </span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td className="write_title">
                        {isEmpty(window.lang["출금 비밀번호"])
                          ? "출금 비밀번호"
                          : window.lang["출금 비밀번호"]}
                      </td>
                      <td className="write_basic">
                        <input
                          data-v-5b7f4dd8=""
                          data-v-66023d98=""
                          type="password"
                          placeholder={
                            isEmpty(window.lang["출금 비밀번호를 입력 하세요"])
                              ? "출금 비밀번호를 입력 하세요"
                              : window.lang["출금 비밀번호를 입력 하세요"]
                          }
                          inputMode="text"
                          className="input1"
                          value={withdrawPassword}
                          onChange={password}
                          style={{ backgroundColor: "#fff" }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
        <div className="con_box30">
          <div className="btn_wrap_center">
            <ul>
              <li>
                <a onClick={onWithdraw}>
                  <span className="btn3_1">
                    {isEmpty(window.lang["출금신청"])
                      ? "출금신청"
                      : window.lang["출금신청"]}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  deposit: state.more.deposit,
  page: state.page,
});

export default connect(mapStateToProps, {
  GetDepositList,
  DoDeposit,
  DeleteDeposit,
})(WithDrawalContent);



// WEBPACK FOOTER //
// ./src/components/account/WithDrawalContent.js